export default "<div class=\"filter-bar\">\n  <div>\n    <h2>Filter</h2>\n  </div>\n  <ng-content></ng-content>\n</div>\n"